enum VehicleType {
  Car = 1,
  Light = 2
}

export default VehicleType;
